import { NgClass, NgStyle } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { Subject } from 'rxjs';
import { FilterParams } from '../../models/filter-params';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-card-table',
  standalone: true,
  imports: [NgClass, NgStyle, MatSidenavModule],
  template: `
    <mat-drawer-container
      [ngClass]="'white_card_content_min_height'"
      [autosize]="true"
      [hasBackdrop]="hasBackdrop"
      (backdropClick)="closeDetail()"
    >
      <mat-drawer
        [ngClass]="'white_card_content_min_height ' + drawerClass"
        #drawer
        mode="over"
        position="end"
        [opened]="showDrawer"
        (openedChange)="openedChange($event)"
      >
        <ng-content select="[card-drawer]"></ng-content>
      </mat-drawer>
      <mat-drawer-content>
        <div class="white_card card_height_100" [ngStyle]="cardStyles">
          <div class="white_card_header" [ngStyle]="headerStyles">
            <div class="row align-items-center">
              <!-- HEADER TITLE -->
              <div class="col-auto d-none d-md-flex">
                <ng-content select="[card-title]"></ng-content>
              </div>
              <!-- SEARCH COMPONENT -->
              <div class="col text-end">
                <ng-content select="[card-search-action]"></ng-content>
              </div>
              <!-- BUTTONS -->
              <div class="col-auto d-none d-md-flex text-end">
                <ng-content select="[card-actions]"></ng-content>
              </div>
              <!-- ADD BTN SMALL DEVICE-->
              <div class="col-auto d-flex d-md-none text-end">
                <ng-content select="[card-sm-actions]"></ng-content>
              </div>
            </div>
          </div>
          <div class="white_card_content">
            <ng-content select="[card-drawer-content]"></ng-content>
          </div>
          <div class="white_card_paginator">
            <ng-content select="[card-drawer-paginator]"></ng-content>
          </div>
        </div>
      </mat-drawer-content>
    </mat-drawer-container>
  `,
  styleUrls: ['./card-table.component.css'],
})
export class CardTableComponent {
  @Input() showDrawer = false;
  @Input() hasBackdrop = true;
  @Input() cardStyles: FilterParams = {};
  @Input() headerStyles: FilterParams = {};
  @Output() openedDrawerChange = new EventEmitter<boolean>();
  @ViewChild(MatDrawer) drawer!: MatDrawer;
  drawerClass = 'drawer-xl';
  stop$ = new Subject<boolean>();

  closeDetail(): void {
    if (this.drawer.opened) {
      this.drawer.close();
    }
  }

  constructor() {}

  openedChange(open: boolean) {
    this.showDrawer = open;
    this.openedDrawerChange.emit(open);
  }
}
